import dayjs from "dayjs";
import { LEAVE_TYPES, LeaveHalfDay, LeaveRequest, LeaveStatus, LeaveType } from "./types";

export const STATUS_CHIP: Record<LeaveStatus, { label: string; color: "warning" | "success" | "error" | "default" }> = {
  PENDING: { label: "Pending", color: "warning" },
  APPROVED: { label: "Approved", color: "success" },
  REJECTED: { label: "Rejected", color: "error" },
  CANCELLED: { label: "Cancelled", color: "default" },
};

export const HALF_LABELS: Record<LeaveHalfDay, string> = { FIRST_HALF: "First half", SECOND_HALF: "Second half" };

export const typeLabel = (type: LeaveType) => LEAVE_TYPES.find((t) => t.value === type)?.label ?? type;

/** "Mon, 6 Oct" / "Mon, 6 Oct – Wed, 8 Oct" / "Mon, 6 Oct · First half" (year added when not this year). */
export const dateRangeLabel = (leave: Pick<LeaveRequest, "fromDate" | "toDate" | "halfDay">) => {
  const from = dayjs(leave.fromDate);
  const to = dayjs(leave.toDate);
  const fmt = (d: dayjs.Dayjs) => d.format(d.year() === dayjs().year() ? "ddd, D MMM" : "ddd, D MMM YYYY");
  if (from.isSame(to, "day")) return leave.halfDay ? `${fmt(from)} · ${HALF_LABELS[leave.halfDay]}` : fmt(from);
  return `${fmt(from)} – ${fmt(to)}`;
};

/** "1 day", "2.5 days", "½ day" */
export const daysLabel = (days: number) => (days === 0.5 ? "½ day" : `${days} day${days === 1 ? "" : "s"}`);
